import NotificationTrackingEvent from './NotificationTrackingEvent';

export default class UserSubscribedToNotificationTrackingEvent extends NotificationTrackingEvent {
  constructor(notificationName: string, instrumentType: string) {
    super('user-subscribed-to-notification', { notificationName, instrumentType });
  }
}
